export default __webpack_public_path__ + "/dist/images/8741525.png";